import React, { useState } from "react";
import { Card, CardHeader, Divider, CardContent, makeStyles, Button, CardActions, List, ListItem, Typography, ListItemText, Grid, CircularProgress, IconButton, ListItemAvatar, Avatar, ListItemSecondaryAction } from "@material-ui/core";
import { transalateReason, translateStatusCode, format_without_time, format_fancy, getTimeInIST, format_display_DDMMYYYY  } from "../Utils";
import { Link as RouterLink, useHistory } from 'react-router-dom';
import clsx from 'clsx';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import moment from "moment";
import { JobService } from "../Services/JobService";
import { RefreshOutlined } from "@material-ui/icons";
import { blue, green, red } from "@material-ui/core/colors";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import SyncProblemIcon from '@material-ui/icons/SyncProblem';
import MomentUtils from "@date-io/moment";

const useStyles = makeStyles(theme => ({
    root: {
        margin: 5, 
        minHeight: 190,
    },
    icon: {
        padding: 2
    },
    content: {
        paddingTop: 0,
        paddingBottom: 0,
        minHeight: 200,
        paddingRight: 0,
        paddingLeft: 0,
    },
    itemDivider: {
        borderBottomColor: 'rgba(0,0,0,0.1)'
    },
    actions: {
        paddingTop: 0,
        justifyContent: 'flex-end'
    },
    arrowForwardIcon: {
        marginLeft: theme.spacing(1)
    },
    select: {
        marginTop: 8
    },
    griditem: {
        cursor: 'move'
    },
    loader: {
        marginTop: 40
    },
    red: {
        color: theme.palette.getContrastText(red[500]),
        backgroundColor: red[500],
    },
    green: {
        color: theme.palette.getContrastText(green[500]),
        backgroundColor: green[500],
    },
    blue: {
        color: theme.palette.getContrastText(blue[500]),
        backgroundColor: blue[500],
    }
}));

const JobStatus = ({ ...props }) => {
    const classes = useStyles();
    const [loading, setLoading] = useState(false);
    const {title, className, isAdmin, showConfirmDialog, closeConfirmDialog, showSnackBar} = props;
    const history = useHistory();
    const [date, setDate] = useState(moment().add(1, "day"));
    const [data, setData] = useState([]);
    const [refresh, setRefresh] = useState(true);
    const [open, setOpen] = React.useState(false);

    React.useEffect(() => {
        if(refresh && date){
            setLoading(true);
            JobService.getJobs(date, date)
            .then((data) => {
                // if(data.jobs.length > 0){
                // 	let j = data.jobs[0];
                // 	job.job_id = j.job_id;
                // 	job.schedule_date = j.schedule_date;
                // 	job.job_type = j.job_type;
                // 	job.startdate = j.startdate;
                // 	job.enddate = j.enddate;
                // 	job.status = j.status;
                // 	j.status_rows.forEach((element, index) => {
                // 		job_rows.push(
                // 			<Grid item key={index+"_title"} xs={6} lg={6}>
                // 				<Typography variant="subtitle1">{}</Typography>
                // 			</Grid>
                // 		);
                // 		job_rows.push(
                // 			<Grid item key={index+"_value"} xs={6} lg={6}>
                // 				<Typography variant="subtitle1">{element.count}</Typography>
                // 			</Grid>
                // 		);
                // 		job_rows.push(
                // 			<Grid item key={index+"_divider"} xs={12} lg={12}>
                // 				<Divider variant="middle"/>
                // 			</Grid>
                // 		);
                // 	});
                // } else {
                // 	job_rows.push(
                // 		<Grid item key={1} xs={12} lg={12}>
                // 			<Typography variant="caption">No Jobs scheduled</Typography>
                // 		</Grid>);
                // }
                setData(data);
                setLoading(false);
            })
            .catch(error => {
                console.log(error);
                setLoading(false);
            })
            setRefresh(false);
        }
    }, [date, refresh]);

    const openLink = jobId => {
        history.push(`/tools/jobs?date=${date.format(format_without_time)}&jobId=${jobId}`)
    }
    
    const reTrigger = () => {
        showConfirmDialog(`Confirm Retrigger for Date ${date.format(format_display_DDMMYYYY)}?`, undefined, () => {
            JobService.triggerB2BScheduler(date.format(format_without_time))
            .then(data => {
                showSnackBar('B2B Scheduler Finished. Refresh to view Status', 'info');
            })
            closeConfirmDialog();
        });
    }

    return (
        <Grid item xl={12} lg={12} xs={12}>
            <Card 
                className={clsx(classes.root, className)}
                //onMouseEnter={() => setIsShown(true)}
                //onMouseLeave={() => setIsShown(false)}
                >
                <CardHeader 
                    title={title}
                    className={classes.griditem}
                    titleTypographyProps={{align: 'left'}}
                    action={
                        <Grid container>
                            {
                                isAdmin && (
                                    <Grid item>
                                        <IconButton style={{marginTop: 4}} onClick={() => reTrigger()}>
                                            <SyncProblemIcon/>
                                        </IconButton>
                                    </Grid>
                                )
                            }
                            <Grid item>
                                <MuiPickersUtilsProvider utils={MomentUtils}>
                                    <DatePicker
                                        open={open}
                                        onOpen={() => setOpen(true)}
                                        onClose={() => setOpen(false)}
                                        variant="inline"
                                        inputVariant="outlined"
                                        margin={"dense"}
                                        label={"Schedule Date"}
                                        value={date}
                                        maxDate={moment().add(4, 'days')}
                                        onChange={(date) => {
                                            setDate(date);
                                            setOpen(false);
                                            setRefresh(true);
                                        }}
                                        format={format_display_DDMMYYYY}
                                        className={classes.formControl}
                                    />
                                </MuiPickersUtilsProvider>
                            </Grid>
                            <Grid item>
                                <IconButton style={{marginTop: 4}} onClick={() => setRefresh(true)}>
                                    <RefreshOutlined/>
                                </IconButton>
                            </Grid>
                        </Grid>
                    }/>
                <Divider />
                <CardContent className={classes.content}>
                    {
                        loading ?
                            <div className={classes.loader}>
                                <CircularProgress/>
                            </div>
                        :
                        <List>
                            {
                                data.jobs && data.jobs.length > 0 ?
                                    data.jobs.map((job, index) => {

                                        let statusText = ``;
                                        job.status_rows.forEach((element) => {
                                            statusText += `${transalateReason(element.status)}: ${element.count} `;
                                        });
                                        let code = translateStatusCode(job.status);

                                        let className;
                                        switch (job.status) {
                                            case "1":
                                                className = classes.green;
                                                break;
                                            case "-1":
                                                className = classes.red;
                                                break;
                                            case "0":
                                            case "2":
                                            default:
                                                className = classes.blue;
                                                break;
                                        }
                                        
                                        return (
                                        <ListItem
                                            classes={{ divider: classes.itemDivider }}
                                            divider
                                            dense
                                            key={index}
                                            style={{textDecoration: 'none'}}
                                            component={RouterLink}
                                            to={`/tools/jobs?date=${date.format(format_without_time)}`}
                                        >
                                            <ListItemAvatar>
                                                <Avatar className={className}>
                                                    {code}
                                                </Avatar>
                                            </ListItemAvatar>
                                            <ListItemText
                                                primary={`Start Time: ${getTimeInIST(job.startdate).format(format_fancy)} End Time: ${job.enddate ? getTimeInIST(job.enddate).format(format_fancy) : '-'}`}
                                                primaryTypographyProps={{ variant: 'subtitle2', color: 'textPrimary' }}
                                                secondary={statusText}
                                            /> 
                                            <Typography color="inherit">{data.rank}</Typography>
                                            <ListItemSecondaryAction edge="end">
                                                <IconButton onClick={() => openLink(job.job_id)}>
                                                    <ArrowForwardIcon />
                                                </IconButton>
                                            </ListItemSecondaryAction>
                                        </ListItem>)
                                    })
                                :
                                    <ListItem
                                        classes={{ divider: classes.itemDivider }}
                                        divider
                                        dense
                                    >
                                        <ListItemText
                                            primary={'No Jobs scheduled'}
                                            primaryTypographyProps={{ variant: 'subtitle2' }}
                                        />
                                    </ListItem>
                            }
                        </List>
                    }
                </CardContent>
                <CardActions className={classes.actions}>
                    <Button
                        color="inherit"
                        component={RouterLink}
                        size="small"
                        to={`/tools/jobs?date=${date.format(format_without_time)}`}
                        variant="text"
                    >
                        More
                    </Button>
                </CardActions>
            </Card>
        </Grid>
    );
};

export default JobStatus;